import { render, staticRenderFns } from "./NsCarousel.vue?vue&type=template&id=36cd6cd9&scoped=true&"
import script from "./NsCarousel.vue?vue&type=script&lang=js&"
export * from "./NsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsCarousel.vue?vue&type=style&index=0&id=36cd6cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cd6cd9",
  null
  
)

export default component.exports